import { render, staticRenderFns } from "./ESGScopeDetails.vue?vue&type=template&id=79e3ddf6"
import script from "./ESGScopeDetails.vue?vue&type=script&lang=js"
export * from "./ESGScopeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports